import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { PaginatorModule } from 'primeng/paginator';
import { CustomerService } from '../../../../services/customer.service';
import { customer, customerGridResponse } from '../../../../model/masters.model';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { LoaderComponent } from '../../../loader/loader.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SalesService } from '../../../../services/sales.service';
import { InventoryService } from '../../../../services/inventory.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-customer-list',
  standalone: true,
  imports: [SharedModule, CommonModule, PaginatorModule, LoaderComponent],
  templateUrl: './customer-list.component.html',
  styleUrl: './customer-list.component.scss'
})
export class CustomerListComponent implements OnInit{
  @ViewChild('dt1') dt1: Table | undefined;
  selectedCustomer: customer[] = [];
  searchKey: any;
  products: any[] = [];

  totalRecords: number = 0;
  loading: boolean = false;
  isSearching = false;


  constructor(private inventoryService: InventoryService, private customerService: CustomerService, private route: Router, private confirmationService: ConfirmationService, private messageService: MessageService, private salesService: SalesService) { }
  customers: customer[] = [];
  start: number = 0;
  rowsPerPage: number = 5;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }

  result: customerGridResponse = {
    customers: [],
    totalRecords: 0
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  loader: boolean = false;

  ngOnInit(): void {
    document.title = 'List Customer';
    this.getCustomers(this.pageRequest);
    this.searchEffect();
  }

  getCustomers(query: gridPageRequest): void {
    //this.loader = true;
    this.customerService.getAllCustomers(query).subscribe({
      next: (data: any) => {
        //console.log(data);

        this.customers = data.customers || [];
        //this.totalRecords = data.totalRecords || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.customers = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  // getCustomers(query: gridPageRequest): void {
  //   // this.loader = true;
  //   this.customerService.getAllCustomers(query).subscribe({
  //     next: (data: any) => {
  //       if (data && data.customers) {
  //         this.result = {
  //           ...data,
  //            customers: data.customers
  //           // customers: data.customers.map((customer: any) => {
  //           //   return {
  //           //     ...customer,
  //           //     customerImage: customer.customerImage
  //           //       ? `data:image/jpeg;base64,${customer.customerImage}`
  //           //       : './assets/no-image.jpg'
  //           //   };
  //           // })
  //         };
  //       } else {
  //         this.customers = [];
  //       }
  //       // this.loader = false;
  //     },
  //     error: error => {
  //       console.error(error);
  //       // this.loader = false;
  //     }
  //   });
  // }



  // loadCustomersLazy(event: any) {
  //   this.loading = true;

  //   const query: gridPageRequestPro = {
  //     pageIndex: event.first / event.rows, // page number
  //     pageSize: event.rows,
  //     // add sorting if needed:
  //     sortField: event.sortField,
  //     sortOrder: event.sortOrder
  //   };

  //   this.customerService.getAllCustomers(query).subscribe({
  //     next: (data: any) => {
  //       this.customers = data.customers || [];
  //       this.totalRecords = data.totalRecords || 0;
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       console.error(err);
  //       this.customers = [];
  //       this.totalRecords = 0;
  //       this.loading = false;
  //     }
  //   });
  // }


  pageCalculation() {
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
  }

  CreateCustomer() {
    this.route.navigate(['/home/createCustomers']);
  }

  deleteCustomer() {

    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var customerIds = _.map(this.selectedCustomer, 'customerId');

        this.customerService.deleteCustomer(customerIds).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer deleted successfully.' });
            this.loader = false;
            this.selectedCustomer = [];
            this.getCustomers(this.pageRequest);
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });
  }

  editCustomer(data?: any) {
    if (data) {
      this.route.navigate(['/home/customerDetails'], { queryParams: { 'customerId': data }, skipLocationChange: false },);
    } else {
      this.route.navigate(['/home/customerDetails'], { queryParams: { 'customerId': this.selectedCustomer[0].customerId }, skipLocationChange: false },);
    }
  }

  loadcustomers(event: any) {
    if (this.searchKey)
      return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getCustomers(this.pageRequest);

  }

  searchCustomer(): void {
    const filterValue = this.searchKey?.trim() || '';
    if (!filterValue) {
      return;
    }
    this.isSearching = true;

    this.salesService.autoSearchCustomer(filterValue).subscribe({
      next: (data: any) => {
        this.customers = data || [];
        //this.totalRecords = data.length;
        this.loading = false;

        // Reset table pagination to first page
        if (this.dt1) {
          this.dt1.first = 0;
        }
      },
      error: (err: any) => {
        console.error(err);
        this.customers = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }


  // searchCustomer(): void {
  //   const filterValue = this.searchKey?.trim();

  //   if (!filterValue) {
  //     return;
  //   }

  //   this.salesService.autoSearchCustomer(filterValue).subscribe(
  //     (data: any) => {
  //       if (data) {
  //         this.result.customers = data.map((customer: any) => {
  //           return {
  //             ...customer,
  //             // customerImage: customer.customerImage
  //             //   ? `data:image/jpeg;base64,${customer.customerImage}`
  //             //   : './assets/no-image.jpg'
  //           };
  //         });

  //         if (this.dt1) {
  //           this.dt1.first = 0;
  //         }
  //       } else {
  //       }
  //     },
  //     (error: any) => {
  //       console.log(error);
  //     }
  //   );
  // }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getCustomers(this.pageRequest);
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Customer Code',	'Customer Name',	'Mobile',	'Email',	'Address',	'City',	'State'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
}

export interface gridPageRequestPro {
  pageIndex: number;           // current page index
  pageSize: number;            // rows per page
  id?: number;                 // optional, e.g., categoryId or filter
  sortField?: string;          // optional, column to sort
  sortOrder?: 'ASC' | 'DESC';  // optional, sort direction
  globalFilter?: string;       // optional, search/filter text
}
